module.exports = __webpack_public_path__ + "342ca3ddceea202340ac2b05658e7eb5.png";